//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PTSVILLALTASCORE',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: '',
        data4: '',
        data5: '',
        data6: '',
        data7: '',
        data8: '',
        data9: '',
        data10: '',
        data11: '',
        data12: ''
      },
      dataList: [
        {name: '无', value: '0'},
        {name: '轻度', value: '1'},
        {name: '中度', value: '2'},
        {name: '重度', value: '3'}
      ],
      dataList1: [
        {name: '无', value: '0'},
        {name: '有', value: '15'}
      ],
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
            result += form[key]
          }
        }
      }
      if (!flag) {
        return ''
      }

      if (result >= 0 && result <= 4) {
        self.descTxt = '无PTS'
      } else if (result >= 5 && result <= 9) {
        self.descTxt = '轻度PTS'
      } else if (result >= 10 && result <= 14) {
        self.descTxt = '中度PTS'
      } else if (result >= 15) {
        self.descTxt = '重度PTS'
      }

      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/PTSVILLALTASCORE.vue